import UrbanClubBenefits from '@/apps/UrbanClubBenefits'
import React from 'react'

const UrbanClubBenefitsBody = (): React.ReactElement => {
  return <UrbanClubBenefits />
}

export default UrbanClubBenefitsBody
